export const ACTIONS = {
  CLEAR_TEACHER_CALL: 'CLEAR_TEACHER_CALL',
  SET_ANALYTICS_META: 'SET_ANALYTICS_META',
  SET_AV_CALL: 'SET_AV_CALL',
  SET_AV_FULLSCREEN: 'SET_AV_FULLSCREEN',
  SET_BROADCAST: 'SET_BROADCAST',
  SET_SELECTED_MEDIA_PROVIDER: 'SET_SELECTED_MEDIA_PROVIDER',
  SET_TEACHER_MEDIA_STATE: 'SET_TEACHER_MEDIA_STATE',
  SET_RM_CALL: 'SET_RM_CALL',
  SET_SCREEN_GRAB: 'SET_SCREEN_GRAB',
  SET_SCREEN_SHARE: 'SET_SCREEN_SHARE',
  UPDATE_TEACHER_CALL: 'UPDATE_TEACHER_CALL',
};

export const setAnalyticsMeta = (type, analyticsMeta) => ({
  type: ACTIONS.SET_ANALYTICS_META,
  payload: {
    type,
    analyticsMeta,
  },
});

export const clearAnalyticsMeta = type => ({
  type: ACTIONS.SET_ANALYTICS_META,
  payload: {
    type,
    analyticsMeta: null,
  },
});

export const clearTeacherCall = () => ({
  type: ACTIONS.CLEAR_TEACHER_CALL,
  payload: {},
});

export const updateTeacherCall = (teacherClassroomId, payload) => ({
  type: ACTIONS.UPDATE_TEACHER_CALL,
  payload: {
    ...payload,
    teacherClassroomId,
  },
});

export const setTeacherMediaState = payload => ({
  type: ACTIONS.SET_TEACHER_MEDIA_STATE,
  payload: {
    ...payload,
  },
});

export const setSelectedMediaProvider = payload => ({
  type: ACTIONS.SET_SELECTED_MEDIA_PROVIDER,
  payload: {
    ...payload,
  },
});

export const setAVFullScreen = payload => ({
  type: ACTIONS.SET_AV_FULLSCREEN,
  payload,
});

export const setBroadcast = (teacherClassroomId, payload) => ({
  type: ACTIONS.SET_BROADCAST,
  payload: {
    ...payload,
    teacherClassroomId,
  },
});

export const setRMCall = (teacherClassroomId, payload) => ({
  type: ACTIONS.SET_RM_CALL,
  payload: {
    ...payload,
    teacherClassroomId,
  },
});
